import { ArrowForwardIos } from '@mui/icons-material';
import { Breadcrumbs } from '@mui/material';
import '../../components/app/common.scss';

function CustomBreadcrumbs({ breadcrumbs }) {
    return (
        <Breadcrumbs separator={<ArrowForwardIos/>} aria-label="breadcrumb">
            {[breadcrumbs]}
        </Breadcrumbs>
    );
}

export default CustomBreadcrumbs;